import type { ComponentProps } from 'react';

const HourGlassWithLetter = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="49"
      viewBox="0 0 76 49"
      fill="none"
      {...props}
    >
      <path
        d="M73.1326 1.5332H23.5586C22.6655 1.5332 21.9414 2.2575 21.9414 3.15096V38.6389C21.9414 39.5323 22.6655 40.2566 23.5586 40.2566H73.1326C74.0258 40.2566 74.7499 39.5323 74.7499 38.6389V3.15096C74.7499 2.2575 74.0258 1.5332 73.1326 1.5332Z"
        fill="white"
      />
      <path
        d="M73.1353 41.0151H23.5613C23.2499 41.0148 22.9417 40.9531 22.6542 40.8335C22.3667 40.7139 22.1057 40.5388 21.8859 40.3182C21.6661 40.0976 21.492 39.8358 21.3735 39.5478C21.255 39.2598 21.1945 38.9512 21.1953 38.6398V3.15187C21.1959 2.52435 21.4453 1.9227 21.8889 1.47898C22.3325 1.03525 22.934 0.785723 23.5613 0.785156L73.1353 0.785156C73.7626 0.785723 74.3641 1.03525 74.8076 1.47898C75.2512 1.9227 75.5007 2.52435 75.5012 3.15187V38.6398C75.5021 38.9512 75.4415 39.2598 75.323 39.5478C75.2045 39.8358 75.0304 40.0976 74.8107 40.3182C74.5909 40.5388 74.3298 40.7139 74.0423 40.8335C73.7549 40.9531 73.4466 41.0148 73.1353 41.0151ZM23.5613 2.28308C23.3309 2.28308 23.11 2.37461 22.9472 2.53754C22.7843 2.70047 22.6928 2.92145 22.6928 3.15187V38.6398C22.6916 38.7546 22.7133 38.8685 22.7564 38.9749C22.7995 39.0813 22.8633 39.1781 22.9441 39.2596C23.0249 39.3412 23.121 39.406 23.2269 39.4502C23.3329 39.4944 23.4465 39.5171 23.5613 39.5171H73.1353C73.3656 39.5171 73.5865 39.4256 73.7494 39.2627C73.9123 39.0997 74.0038 38.8788 74.0038 38.6483V3.15187C74.0038 2.92145 73.9123 2.70047 73.7494 2.53754C73.5865 2.37461 73.3656 2.28308 73.1353 2.28308H23.5613Z"
        fill="#E3E0DB"
      />
      <path
        d="M21.9414 10.0994V4.23613C21.9532 3.50926 22.2525 2.81671 22.7738 2.31015C23.295 1.80358 23.9957 1.52429 24.7224 1.53345H71.9646C72.6915 1.52373 73.3925 1.80283 73.9138 2.30951C74.4352 2.8162 74.7343 3.50908 74.7456 4.23613V10.0994H21.9414Z"
        fill="#E3E0DB"
      />
      <path
        d="M68.9204 14.8076H45.2266V16.3055H68.9204V14.8076Z"
        fill="#B5ADA2"
      />
      <path
        d="M68.9204 19.3906H45.2266V20.8885H68.9204V19.3906Z"
        fill="#B5ADA2"
      />
      <path
        d="M41.8662 19.0649C41.7221 20.1491 41.2357 21.1589 40.4779 21.9474C39.9642 22.4798 39.3489 22.9037 38.6685 23.1939C37.9881 23.4841 37.2564 23.6348 36.5167 23.637C35.7771 23.6392 35.0445 23.4928 34.3624 23.2067C33.6802 22.9205 33.0625 22.5003 32.5457 21.9709C32.0051 21.4133 31.5977 20.7406 31.354 20.0031C31.1102 19.2656 31.0364 18.4826 31.1381 17.7125C31.5167 14.8387 34.2421 12.8122 37.2006 13.1974C40.1591 13.5825 42.2534 16.1932 41.8662 19.0649Z"
        fill="#E3E0DB"
      />
      <path
        d="M36.4788 18.362C37.4724 18.362 38.2778 17.5812 38.2778 16.618C38.2778 15.6548 37.4724 14.874 36.4788 14.874C35.4852 14.874 34.6797 15.6548 34.6797 16.618C34.6797 17.5812 35.4852 18.362 36.4788 18.362Z"
        fill="#B5ADA2"
      />
      <path
        d="M40.4791 21.9476C39.9654 22.48 39.3501 22.9039 38.6697 23.1941C37.9893 23.4844 37.2576 23.635 36.5179 23.6372C35.7783 23.6394 35.0457 23.4931 34.3636 23.2069C33.6814 22.9207 33.0637 22.5005 32.5469 21.9712C33.3191 20.4304 34.7952 19.3904 36.4959 19.3819C38.1965 19.3733 39.694 20.409 40.4791 21.9476Z"
        fill="#B5ADA2"
      />
      <path
        d="M25.5781 15.1035L8.64844 20.7913L10.1972 25.131C10.8866 27.0447 12.2239 28.6565 13.9772 29.6869L13.9387 29.6997L13.9793 29.6869C15.5014 30.5934 17.2535 31.0394 19.0236 30.9708C19.4406 31.4262 19.7615 31.9612 19.967 32.5436C20.1749 33.1225 20.2609 33.7381 20.2194 34.3518C18.7911 35.3516 17.695 36.7566 17.0726 38.3855L17.0341 38.4005L17.0726 38.3876C16.3562 40.264 16.3357 42.3351 17.0149 44.2253L18.5637 48.5671L35.4955 42.8814L33.9467 38.5396C33.2593 36.628 31.9261 35.0167 30.1774 33.9837L30.2288 33.9666L30.1753 33.9837C28.6574 33.0821 26.9123 32.6364 25.1481 32.6998C24.7258 32.2478 24.4004 31.7141 24.1922 31.1315C23.984 30.5489 23.8972 29.9298 23.9374 29.3124C25.359 28.3129 26.4496 26.9112 27.0692 25.2872C27.0866 25.2799 27.1045 25.2735 27.1226 25.268L27.0713 25.2851C27.7871 23.4079 27.8076 21.3364 27.129 19.4453L25.5781 15.1035Z"
        fill="#75CAC3"
      />
      <path
        d="M10.4453 22.1191L11.3309 24.5971C12.4005 27.6122 15.2714 29.5317 18.3732 29.6302C19.0544 29.6356 19.7185 29.8433 20.2814 30.227C20.8444 30.6106 21.2807 31.1529 21.535 31.785C21.6077 31.9755 21.6783 32.1702 21.7489 32.3649C21.9015 32.7929 22.0441 33.2159 22.1767 33.6339C22.608 35.0164 22.5968 36.4993 22.1446 37.8751L19.2567 46.7921L33.8418 41.8939L25.8604 36.5976C24.6352 35.7962 23.6837 34.6398 23.133 33.2829C22.9732 32.8821 22.8178 32.4712 22.6666 32.0504C22.596 31.8556 22.5297 31.663 22.4655 31.4726C22.26 30.8314 22.2567 30.1424 22.4561 29.4993C22.6555 28.8561 23.0479 28.2899 23.58 27.8776C24.732 26.9452 25.5815 25.6918 26.0209 24.2761L10.4453 22.1191Z"
        fill="#355D60"
      />
      <path
        d="M26.26 13.2938L7.08984 19.7324L7.56648 21.1524L26.7367 14.7138L26.26 13.2938Z"
        fill="#4F9493"
      />
      <path
        d="M36.2015 41.1414L17.0312 47.5801L17.5079 49.0001L36.6781 42.5615L36.2015 41.1414Z"
        fill="#4F9493"
      />
      <path
        d="M53.0747 27.5078H32.5469V29.0057H53.0747V27.5078Z"
        fill="#E3E0DB"
      />
      <path
        d="M53.0747 31.1387H32.5469V32.6366H53.0747V31.1387Z"
        fill="#E3E0DB"
      />
      <path
        d="M6.32832 23.4086L0.5 23.8408L0.610713 25.3346L6.43903 24.9024L6.32832 23.4086Z"
        fill="#5BAFA9"
      />
      <path
        d="M7.45474 27.6728L2.1875 30.1309L2.82058 31.4883L8.08782 29.0303L7.45474 27.6728Z"
        fill="#5BAFA9"
      />
      <path
        d="M9.64213 30.7225L6.13672 35.2578L7.32137 36.174L10.8268 31.6388L9.64213 30.7225Z"
        fill="#5BAFA9"
      />
    </svg>
  );
};

export default HourGlassWithLetter;
